import Icon from "@Components/generic/icon";
import { faHourglass } from "@fortawesome/pro-regular-svg-icons";
import useDemoAccount from "@hooks/common/user/use-demo-account";
import useI18n from "@i18n";
import { Alert, Stack, Typography } from "@mui/material";
import { format } from "date-fns";

const HeaderPopoverDemoAlert = () => {
  const { isDemo, getExpiringProducts } = useDemoAccount();
  const { i18n } = useI18n();
  
  if (!isDemo) {
    return null;
  }

  const expiringProducts = getExpiringProducts();
  const demoExpiryDate = expiringProducts?.earliestProduct.expiryDate; // Assuming demo account has only one expiring product for now

  return (
    <Alert severity="info" iconMapping={{ info: <Icon icon={faHourglass} size="sm" /> }}>
      <Stack spacing={1}>
        {i18n("header.demo-alert.message")}
        <Typography variant="textS500" color="dsNeutral.v300">
          {demoExpiryDate &&
            i18n("header.demo-alert.expiry-line", {
              date: format(demoExpiryDate, "MMM dd, yyyy hh:mm"),
            })}
        </Typography>
      </Stack>
    </Alert>
  );
};

export default HeaderPopoverDemoAlert;
